/**
 * CEFR ladder used by the vocabulary-test landing. Thresholds match
 * {@code TestVocabularyServiceImpl.getLanguageLevel} on the BE — keep them
 * aligned when the BE updates them.
 */
export interface CefrLevel {
  id: 'A1' | 'A2' | 'B1' | 'B2' | 'C1' | 'C2';
  start: number;
  name: string;
  desc: string;
}

export const CEFR_LEVELS: CefrLevel[] = [
  { id: 'A1', start: 500, name: 'Beginner', desc: 'Прості фрази й базові потреби' },
  { id: 'A2', start: 1400, name: 'Elementary', desc: 'Повсякденні теми, прості речення' },
  { id: 'B1', start: 2100, name: 'Intermediate', desc: 'Впевнене спілкування на щоденні теми' },
  { id: 'B2', start: 3900, name: 'Upper-Intermediate', desc: 'Складніші тексти й абстрактні теми' },
  { id: 'C1', start: 6000, name: 'Advanced', desc: 'Вільне, гнучке володіння мовою' },
  { id: 'C2', start: 8600, name: 'Proficiency', desc: 'Майже на рівні носія' },
];

export const levelOf = (count: number): CefrLevel => {
  let cur = CEFR_LEVELS[0];
  for (const l of CEFR_LEVELS) {
    if (count >= l.start) cur = l;
  }
  return cur;
};

export const nextLevelOf = (level: CefrLevel): CefrLevel | null => {
  const i = CEFR_LEVELS.findIndex((l) => l.id === level.id);
  return CEFR_LEVELS[i + 1] || null;
};

export const fmt = (n: number) => n.toLocaleString('uk-UA');
